import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

export const EmptyState = () => {
  const { t } = useTranslation("ai");

  return (
    <div className="flex flex-col items-center justify-center h-full text-center">
      <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
        <Sparkles className="w-6 h-6 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-medium mb-2">{t("Ask me anything about your data")}</h2>
      <p className="text-sm text-muted-foreground mb-6 max-w-md">
        {t("I can help you analyze your patient data, find trends, and answer questions using natural language.")}
      </p>
      <div className="space-y-2 text-sm text-muted-foreground">
        <p className="font-medium text-foreground">{t("Try asking:")}</p>
        <ul className="space-y-1">
          <li>{t('"How many patients do I have?"')}</li>
          <li>{t('"Show me patients by state"')}</li>
          <li>{t('"What are the most common patient tags?"')}</li>
        </ul>
      </div>
    </div>
  );
};
